import styled from 'styled-components';
import FontAwesomeIcon from '../../common/FontAwesomeIcon';

const PublicHeaderInfo = (props) => {
    const {
        foto,
        name,
        repoId,
        sisId,
        id,
        street,
        city,
        country,
        zip,
        birthday,
        profession,
        job,
        company,
        personalEmail,
        workEmail,
        phone,
        linkedin,
        facebook,
        instagram,
        twitter,
    } = props;

    return (
        <PublicHeaderInfoContainer>
            <Section>
                <PhotoWrapper>
                    <Photo src={foto} alt="user-photo" />
                </PhotoWrapper>
                <InfoWrapper>
                    <Name>{name}</Name>
                    <Span>
                        #C{id}-R{repoId}-S{sisId}
                    </Span>
                </InfoWrapper>
            </Section>
            <Section bt>
                <SubTitle>Acerca de mí</SubTitle>
                <Description>-</Description>
            </Section>
            <Section bt>
                <SubTitle>Mis datos</SubTitle>
                <Item>
                    <Icon>
                        <FontAwesomeIcon
                            icon="fa-light fa-location-dot"
                            size={18}
                            color="#b31d15"
                        />
                    </Icon>
                    <Description>
                        {street}, {zip}, {city}, {country.name}
                    </Description>
                </Item>
                <Item>
                    <Icon>
                        <FontAwesomeIcon
                            icon="fa-light fa-cake-candles"
                            size={18}
                            color="#b31d15"
                        />
                    </Icon>
                    <Description>{birthday || '-'}</Description>
                </Item>
                <Item>
                    <Icon>
                        <FontAwesomeIcon
                            icon="fa-light fa-graduation-cap"
                            size={18}
                            color="#b31d15"
                        />
                    </Icon>
                    <Description>{profession || '-'}</Description>
                </Item>
                <Item>
                    <Icon>
                        <FontAwesomeIcon
                            icon="fa-light fa-briefcase"
                            size={18}
                            color="#b31d15"
                        />
                    </Icon>
                    <Description>{job || '-'}</Description>
                </Item>
                <Item>
                    <Icon>
                        <FontAwesomeIcon
                            icon="fa-light fa-building"
                            size={18}
                            color="#b31d15"
                        />
                    </Icon>
                    <Description>{company || '-'}</Description>
                </Item>
            </Section>
            <Section bt>
                <SubTitle>Contacto</SubTitle>
                <Item>
                    <Icon>
                        <FontAwesomeIcon
                            icon="fa-light fa-envelope"
                            size={18}
                            color="#b31d15"
                        />
                    </Icon>
                    <Description>
                        {personalEmail || { workEmail } || '-'}
                    </Description>
                </Item>
                <Item>
                    {/* Telefono */}
                    <Icon>
                        <FontAwesomeIcon
                            icon="fa-light fa-phone"
                            size={18}
                            color="#b31d15"
                        />
                    </Icon>
                    <Description>{phone}</Description>
                </Item>
            </Section>
            <Section bt>
                <SubTitle>Mis Redes Sociales</SubTitle>
                <Row>
                    <ButtonRedes
                        onClick={() => window.open(linkedin, '_blank')}
                        disabled={!linkedin}
                    >
                        <FontAwesomeIcon
                            icon="fa-brands fa-linkedin"
                            size={24}
                            color={linkedin ? '#b31d15' : '#a8a8a8'}
                        />
                    </ButtonRedes>
                    <ButtonRedes
                        onClick={() => window.open(facebook, '_blank')}
                        disabled={!facebook}
                    >
                        <FontAwesomeIcon
                            icon="fa-brands fa-square-facebook"
                            size={24}
                            color={facebook ? '#b31d15' : '#a8a8a8'}
                        />
                    </ButtonRedes>
                    <ButtonRedes
                        onClick={() => window.open(instagram, '_blank')}
                        disabled={!instagram}
                    >
                        <FontAwesomeIcon
                            icon="fa-brands fa-square-instagram"
                            size={24}
                            color={instagram ? '#b31d15' : '#a8a8a8'}
                        />
                    </ButtonRedes>
                    <ButtonRedes
                        onClick={() => window.open(twitter, '_blank')}
                        disabled={!twitter}
                    >
                        <FontAwesomeIcon
                            icon="fa-brands fa-square-x-twitter"
                            size={24}
                            color={twitter ? '#b31d15' : '#a8a8a8'}
                        />
                    </ButtonRedes>
                </Row>
            </Section>
            {/* <Section bt>
                <ButtonShared>
                    <FontAwesomeIcon
                        icon="fa-light fa-share-nodes"
                        size={18}
                        color="#b31d15"
                    />
                    Compartir perfil
                </ButtonShared>
            </Section> */}
        </PublicHeaderInfoContainer>
    );
};

export default PublicHeaderInfo;

const PublicHeaderInfoContainer = styled.div`
    width: 100%;
    flex-basis: 30%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    padding: 1.5rem;
    border: 1px solid #a8a8a8;
    gap: 1rem;
    box-sizing: border-box;
`;

const Section = styled.section`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    border-top: ${(props) => (props.bt ? '1px solid #bfbfbf' : 'none')};
    box-sizing: border-box;
    padding-top: ${(props) => (props.bt ? '1rem' : '0')};
`;

const PhotoWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

const Photo = styled.img`
    width: 120px;
    height: 120px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
    max-width: 120px;
    max-height: 120px;
`;

const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;

    @media (max-width: 768px) {
        align-items: center;
    }
`;

const Name = styled.h1`
    font-size: 20px;
    font-weight: 600;
    color: #b31d15;
    text-align: center;
    line-height: 29px;
`;

const Span = styled.span`
    color: #a8a8a8;
    font-size: 0.875rem;
    text-align: center;
`;

const SubTitle = styled.h3`
    font-size: 1rem;
    color: #000;
    font-weight: 600;
`;
const Description = styled.p`
    font-size: 1rem;
    color: #7f7f7f;
`;

const Item = styled.div`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 8px;
    gap: 0.5rem;
`;

const Icon = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Row = styled.div`
    display: flex;
    gap: 1.5rem;
    align-items: center;
`;

const ButtonRedes = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        color: #a8a8a8;
    }
`;

const ButtonShared = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    color: #b31d15;
    border: 1px solid #b31d15;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;

    &:hover {
        background-color: #f8f8f8;
        filter: brightness(1.1);
    }

    svg {
        margin-right: 0.5rem;
    }
`;
